import React, { FC } from 'react'

import { Box, Stack, Typography, useTheme } from '@mui/material'

import { IndicatorsPropsType } from './types'

export const Indicators: FC<IndicatorsPropsType> = ({
  positiveLabel,
  negativeLabel,
  middleLabel,
}) => {
  const { palette, spacing } = useTheme()

  return (
    <Stack
      spacing={{ xs: 1, md: 2 }}
      direction={'row'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Box display="flex" gap={spacing(1.5)} alignItems="center">
        <Box
          bgcolor={palette.green[400]}
          width={spacing(1)}
          height={spacing(1)}
          borderRadius={spacing(0.5)}
        />
        <Typography fontWeight={500}>{positiveLabel}</Typography>
      </Box>
      {middleLabel && (
        <Box display="flex" gap={spacing(1.5)} alignItems="center">
          <Box
            bgcolor={palette.yellow[400]}
            width={spacing(1)}
            height={spacing(1)}
            borderRadius={spacing(0.5)}
          />
          <Typography fontWeight={500}>{middleLabel}</Typography>
        </Box>
      )}
      <Box display="flex" gap={spacing(1.5)} alignItems="center">
        <Box
          bgcolor={palette.red[400]}
          width={spacing(1)}
          height={spacing(1)}
          borderRadius={spacing(0.5)}
        />
        <Typography fontWeight={500}>{negativeLabel}</Typography>
      </Box>
    </Stack>
  )
}
